import { createEffect, onCleanup } from "solid-js";
import {
  customShadowlessElement,
  toHyphenated,
  correctElementType,
} from "@brytdesigns/web-component-core/utils";
import { withDrawerElementContext } from "@brytdesigns/web-component-drawer";

customShadowlessElement(
  "flourish-header",
  {
    dataIsAtScrollTop: true,
    dataDrawerIsOpen: false,
    dataDrawerTarget: "",
    dataPrimaryColorScheme: "",
    dataSecondaryColorScheme: "",
  },
  correctElementType((props, { element }) => {
    withDrawerElementContext(
      () => () => document.querySelector<Element>(props.dataDrawerTarget)!,
      () => ({
        primaryColorScheme: props.dataPrimaryColorScheme,
        secondaryColorScheme: props.dataSecondaryColorScheme,
      }),
      (context, props) => {
        const [state] = context;
        const { primaryColorScheme, secondaryColorScheme } = props;
        createEffect(() => {
          const elementsWithPrimary = Array.from(
            element.querySelectorAll(`.color-${primaryColorScheme}`),
          );
          const elementsWithSecondary = Array.from(
            element.querySelectorAll(`.color-${secondaryColorScheme}`),
          );
          if (state.isOpen) {
            element.setAttribute(toHyphenated("dataDrawerIsOpen"), "true");
            elementsWithPrimary.forEach((element) => {
              element.classList.remove(`color-${primaryColorScheme}`);
              element.classList.add(`color-${secondaryColorScheme}`);
            });
          } else {
            element.setAttribute(toHyphenated("dataDrawerIsOpen"), "false");
            elementsWithSecondary.forEach((element) => {
              element.classList.remove(`color-${secondaryColorScheme}`);
              element.classList.add(`color-${primaryColorScheme}`);
            });
          }
        });
      },
    );

    // Add data attribute when element is at the top of the viewport
    createEffect(() => {
      const sentinel = document.createElement("div");
      sentinel.style.cssText = `display:block;height:1px;margin:0;padding:0;border:0;position:absolute;top:0px;left:0px;right:0px;`;
      sentinel.setAttribute("aria-hidden", "true");
      document.body.prepend(sentinel);
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            // When the viewport's top aligns with the page's top
            if (entry.isIntersecting && entry.boundingClientRect.top === 0) {
              element.setAttribute(toHyphenated("dataIsAtScrollTop"), "true");
            } else {
              element.setAttribute(toHyphenated("dataIsAtScrollTop"), "false");
            }
          }
        },
        {
          root: null, // viewport
          rootMargin: "0px",
          threshold: 1, // triggers as soon as any intersection happens
        },
      );

      // Observe the <html> element itself
      observer.observe(sentinel);

      return onCleanup(() => {
        observer.disconnect();
        sentinel.remove();
      });
    });
  }),
);
